module.exports = __webpack_public_path__ + "static/media/Banner_Togaf.26181456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curso_img/splint/Banner_Togaf.png
// module id = 44
// module chunks = 0